import {createContext} from 'react';
import {SubscribeToEvents} from './types';

const SubscribeToEventsContext = createContext<SubscribeToEvents>(() => {});

export default SubscribeToEventsContext;
